<div dwRow>
    <div class="col-12">
        <label class="label">Request Details</label>
        <textarea [(ngModel)]="request" rows="4" cols="60" class="form-control">

        </textarea>
    </div>
</div>
